export default "__VITE_ASSET__BvMz$g7q__"